import type { Point } from './combatModel'

export interface HoneyProjectileState extends Point {
  targetId: number
  targetX: number
  targetY: number
  speed: number
  complete: boolean
}

export function createHoneyProjectile(
  from: Point,
  targetId: number,
  target: Point,
  speed: number,
): HoneyProjectileState {
  return {
    x: Math.round(from.x),
    y: Math.round(from.y),
    targetId,
    targetX: Math.round(target.x),
    targetY: Math.round(target.y),
    speed,
    complete: false,
  }
}

export function stepHoneyProjectile(
  projectile: HoneyProjectileState,
  deltaMs: number,
  liveTarget: Point | null,
): { state: HoneyProjectileState; hit: boolean } {
  if (projectile.complete) return { state: projectile, hit: false }
  const targetX = liveTarget ? Math.round(liveTarget.x) : projectile.targetX
  const targetY = liveTarget ? Math.round(liveTarget.y) : projectile.targetY
  const dx = targetX - projectile.x
  const dy = targetY - projectile.y
  const distance = Math.hypot(dx, dy)
  const step = Math.max(0, projectile.speed * Math.max(0, deltaMs) / 1000)

  if (distance === 0 || step >= distance) {
    return {
      state: { ...projectile, x: targetX, y: targetY, targetX, targetY, complete: true },
      hit: true,
    }
  }

  return {
    state: {
      ...projectile,
      x: Math.round(projectile.x + dx / distance * step),
      y: Math.round(projectile.y + dy / distance * step),
      targetX,
      targetY,
    },
    hit: false,
  }
}
